export class CarrierImportDuplicationError {

  public message: string;
  public fieldName: string;
  public fieldValue: string;
  public identity: string;
  public duplicateIdentities: string[];
  public type: 'MISSING'|'CMAWEB_DUPLICATE'|'FILE_DUPLICATE'|'INEXISTANT'|'INVALID';

  static fromDto(data: any): CarrierImportDuplicationError {
    if (!data) {
      return null;
    }

    const duplicationError = new CarrierImportDuplicationError();

    duplicationError.message             = data.message;
    duplicationError.fieldName           = data.field_name;
    duplicationError.fieldValue          = data.field_value;
    duplicationError.identity            = data.identity;
    duplicationError.duplicateIdentities = data.duplicate_identities;

    return duplicationError;
  }

  static toDtos(data: CarrierImportDuplicationError[]) {
    return data.map(d => ({
      message: d.message,
      field_name: d.fieldName,
      field_value: d.fieldValue,
      identity: d.identity,
      duplicates_identities: d.duplicateIdentities
    }));
  }
}
